import { ITasklistProcess } from '@/api/tasklist';
import { listIcons } from '@/utils/lib/iconHub';
import { useNavigate } from 'react-router-dom';

interface BusinessProcessItemProps {
  businessProcess: ITasklistProcess;
}

export default function BusinessProcessItem(props: BusinessProcessItemProps) {
  const navigate = useNavigate();
  const { businessProcess } = props;

  let icon: string = listIcons[businessProcess.key] || listIcons.default;
  if (businessProcess.key.toLowerCase().includes('reminder')) icon = listIcons['Reminder'];

  return (
    <button className="flex flex-col space-y-2" onClick={() => navigate(`/tasklist/${businessProcess.key}`)}>
      <div className="bg-white shadow-md aspect-square rounded-md flex justify-center items-center cursor-pointer duration-300 hover:border-teal-500 hover:border-2">
        <img src={`/icons/BusinessProcesses/${icon}.svg`} alt="" />
      </div>
      <span className="mx-auto text-center text-sm text-slate-500">{businessProcess.name}</span>
    </button>
  );
}
